/* eslint-disable */

const roleTranslation = {
  reseller: 'Utilisateur',
  chief: 'Responsable',
  superChief: 'Admin de groupe',
};

export { roleTranslation };
